import {
  CHECKAUTH,
  GETSTORAGE,
  LOGIN,
  LOGOUT,
  REGISTER,
  SETSTORAGE,
  SET_ACCOUNT,
  SET_IMAGE,
  SET_POSTS,
} from "../actions/auth.action";

export default (state, action) => {
  switch (action.type) {
    case LOGIN: {
      return {
        ...state,
        isLogged: true,
        token: action.payload.token,
      };
    }
    case SETSTORAGE: {
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("exp", new Date().getTime() + 7200 * 60000);
    }
    case REGISTER: {
      return {
        ...state,
        isLogged: true,
        token: action.payload.token,
      };
    }
    case LOGOUT: {
      localStorage.removeItem("token");
      localStorage.removeItem("exp");
      return action.payload;
    }
    case SET_ACCOUNT: {
      return { ...state, data: action.payload.data };
    }
    case SET_POSTS: {
      return { ...state, posts: action.payload.data };
    }
    case SET_IMAGE: {
      return {
        ...state,
        data: {
          ...state.data,
          account_image_path: {
            ...state.data.account_image_path,
            String: action.payload.data,
          },
        },
      };
    }
    case SET_POSTS: {
      return {
        ...state,
        posts: action.payload.data,
      };
    }
  }
  return state;
};
